import React from "react";

const RightDash = ({ children, resizeMenu, setResizeMenu }) => {
  return (
    <div className={`right ${resizeMenu ? "minright" : "maxright"}`}>
      {children}
    </div>
  );
};

export default RightDash;
